import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
dayjs.extend(calendar);

export const createdAt = (last_message) => {
    return last_message
        ? dayjs(last_message.created_at).calendar(null, {
              sameDay: 'H:mm',
              nextDay: '[Tomorrow]',
              nextWeek: '[Next] dddd',
              lastDay: '[Yesterday at ]H:mm',
              lastWeek: 'DD MMMM',
              sameElse: 'DD MMMM',
          })
        : null;
};

export const checkForBadWords = (item) => {
    let result = '';
    if (!item.content || !item.content.hasOwnProperty('text')) {
        return;
    }

    let withStart = item.content.text.split('<a');

    withStart.forEach((msgItem, i) => {
        if (!msgItem.includes('href=')) {
            if (item.hide_keywords) {
                msgItem = msgItem.replace(/\[badword\].*\[\/badword\]/g, '****');
                withStart[i] = msgItem ? msgItem : '';
            } else {
                msgItem = msgItem.replace(/\[\/?badword\]/g, '');
            }
            withStart[i] = msgItem;
        } else {
            let a = msgItem.split('</a>')[0];
            a = a.replace(/\[\/?badword\]/g, '');
            const href = a.split("href='")[1].split("'")[0];
            withStart[i] = href;
        }
    });

    result = withStart.join('');
    result = result.replace(/\<a/g, '');
    result = result.replace(/\<\/a\>/g, '');

    if (!result.length) {
        result = 'no text';
    }

    return result;
};

export const messageData = (last_message, reported) => {
    let messageTextData = '';
    try {
        let array = null;
        let urlRegExpression = null;
        let text = '';
        switch (last_message.type) {
            case 'text':
                array = last_message.content.text.split('[badword]');
                urlRegExpression = new RegExp(
                    '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?'
                );

                array.map((it, i) => {
                    if (urlRegExpression.test(it)) {
                        array[i] = createLinksInMessages(it);
                    }
                    if (it.includes('[/badword]')) {
                        if (last_message.hide_keywords) {
                            array[i] = '***' + it.split('[/badword]')[1];
                        } else {
                            array[i] = it.split('[/badword]')[0] + ' ' + it.split('[/badword]')[1];
                        }
                    }
                });
                text = array.join('');
                messageTextData = text;
                break;
            case 'autotext':
                messageTextData = last_message.content.text;
                break;
            case 'joined':
                messageTextData = `${last_message.content.user} added
                        ${last_message.content.ambassador}
                        ${
                            last_message.ambassador_type
                                ? ', ' + last_message.content.university + ' ' + last_message.ambassador_type + ', '
                                : ' from ' + last_message.content.university + ' '
                        }
                        to the chat`;
                break;
            case 'joined-admin':
                messageTextData = `${last_message.content.adminName} joined the chat`;
                break;
            case 'invite':
                messageTextData = `${last_message.content.user} added ${last_message.content.admin}, ${last_message.content.university} staff representative to the chat.`;
                break;
            case 'flagged':
                messageTextData = 'Conversation has been ' + (reported ? 'reported' : 'unreported');
                break;
            case 'closed':
                messageTextData = 'Conversation has been closed';
                break;
            case 'reopened':
                messageTextData = 'Conversation has been reopened';
                break;
            case 'delete':
                messageTextData = 'Deleted';
                break;
        }
    } catch (err) {
        // TODO: handle error?
    }

    return messageTextData;
};

export const createLinksInMessages = (text) => {
    // eslint-disable-next-line no-useless-escape
    return (text || '').replace(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi, function (_, space, url) {
        var hyperlink = url;
        if (!hyperlink.match('^https?://')) {
            hyperlink = 'https://' + hyperlink;
        }
        return space + '<a href="' + hyperlink + '" target="_blank">' + url + '</a>';
    });
};
